import { DonutProgressBar } from './donut-progress-bar'

const COLORS = {
  GREEN: '#5DD39E',
  ORANGE: '#F3B03E',
  RED: '#E41B0C',
}

const getProgressColor = (progress: number): string =>
  progress <= 30 ? COLORS.RED : progress < 80 ? COLORS.ORANGE : COLORS.GREEN

export const DonutProgressWrapper = ({ value = 0, label }) => {
  const progressColor = getProgressColor(value)

  return (
    <div className="flex items-center">
      <DonutProgressBar value={value} size={57} thickness={7} color={progressColor} />
      <div className="ml-2">
        <span className="font-roboto font-semibold text-3xl">{value}%</span>
        <p className="text-cv-blue-400 text-[12px] font-medium">{label}</p>
      </div>
    </div>
  )
}
